import { Component, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { CarouselComponent, OwlOptions } from "ngx-owl-carousel-o";

@Component({
  selector: "staffs-home2",
  templateUrl: "./staffs-home2.component.html",
  styleUrls: ["./staffs-home2.component.scss"],
})
export class StaffsHome2Component implements OnInit
{


  @ViewChild("owlCarousel") owlCarousel: CarouselComponent;

  lang: string = this.cookie_s.get('lang') || 'en';


  staffs = [
    {
      photo: "../../../assets/images/team/9.jpeg",
      name: "حسام رضوان",
      name_en: "Hossam Radwan",
      title: "قائد الفريق",
      title_en: "Team Leader",
    },
    {
      photo: "../../../assets/images/team/1.jpg",
      name: "محمد الحاوي",
      name_en: "Mohamed Elhawy",
      title: "مطور ويب",
      title_en: "Front-End Developer",
    },
    {
      photo: "../../../assets/images/team/2.jpg",
      name: "احمد الحلواني",
      name_en: "Ahmed Halawany",
      title: "مطور قاعدة البيانات",
      title_en: "Back-End Developer",
    },
    {
      photo: "../../../assets/images/team/6.jpeg",
      name: "علاء رضوان",
      name_en: "Alaa Radwan",
      title: "مطور اندرويد",
      title_en: "Android Developer",
    },
    {
      photo: "../../../assets/images/team/8.jpg",
      name: "اسلام محمد",
      name_en: "Eslam Mohamed",
      title: "مطور ايفون",
      title_en: "IOS Developer",
    },
    {
      photo: "../../../assets/images/team/4.jpg",
      name: "عبدالله ايهاب",
      name_en: "Abdallah Ehab",
      title: "مطور ايفون",
      title_en: "IOS Developer",
    },
    {
      photo: "../../../assets/images/team/16.jpeg",
      name: "عبدالرحمن احمد",
      name_en: "Abdelrahman Ahmed",
      title: "مطور ويب",
      title_en: "Front-End Developer",
    },
    {
      photo: "../../../assets/images/team/14.jpeg",
      name: "احمد كامل",
      name_en: "Ahmed Kamel",
      title: "مطور ويب",
      title_en: "Front-End Developer",
    },
    {
      photo: "../../../assets/images/team/7.jpg",
      name: "مريم محمد",
      name_en: "Mariam Mahmoud",
      title: "مهندس ضمان جودة",
      title_en: "QA Engineer",
    },
    {
      photo: "../../../assets/images/team/9.jpg",
      name: "بيتر شوقي",
      name_en: "Peter Shawki",
      title: "مطور اندرويد",
      title_en: "Android Developer",
    },
    {
      photo: "../../../assets/images/team/12.jpg",
      name: "محمد اشرف",
      name_en: "Mohamed Ashraf",
      title: "مطور اندرويد",
      title_en: "Android Developer",
    },
    {
      photo: "../../../assets/images/team/15.jpeg",
      name: "ابانوب نبيل",
      name_en: "Abanoub nabil",
      title: "مهندس ضمان جودة",
      title_en: "QA Engineer",
    },
    {
      photo: "../../../assets/images/team/17.jpeg",
      name: "ريعان مصطفى",
      name_en: "Raiaan Mostafa",
      title: "مطور ايفون",
      title_en: "IOS Developer",
    },
  ];

  owlOptions: OwlOptions = {
    loop: true,
    dots: false,
    autoplay: true,
    autoplayHoverPause: true,
    touchDrag: true,
    animateOut: "fadeOut",
    rtl: this.cookie_s.get('lang') == "ar",
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 2,
      },
      740: {
        items: 3,
      },
      940: {
        items: 4,
      },
    },
  };

  constructor(
    private cookie_s: CookieService
  ) {}

  ngOnInit(): void {}

  prev() {
    this.owlCarousel.prev();
  }
  next() {
    this.owlCarousel.next();
  }
}
